<div class="position-absolute bottom-7 start-20">
  <app-scale-control></app-scale-control>
</div>

<app-bottom-page-panel>
  <app-history-mode
    *hasPermissionAny="[Permissions.RCS_Historic_All_Read]"
    [isHistoryVisible]="isHistoryVisible"
    (historyToggled)="toggleHistory()"
    data-cy="historic-view-toggle"
  ></app-history-mode>
  <app-auto-refresh
    (intervalSet)="setLiveModeRefreshInterval($event)"
    [isActive]="isInLiveMode"
    [isDisabled]="isHistoryVisible"
    [intervalInSecondsInput]="displayRefreshInterval"
  ></app-auto-refresh>
</app-bottom-page-panel>
<app-map-navigation>
  <app-obstacle-view-actions-bar
    [isLegendVisible]="isLegendVisible"
    (toggleLegend)="toggleLegend()"
  ></app-obstacle-view-actions-bar>
</app-map-navigation>
<app-obstacle-layer-config [providerInfo$]="this.ProviderInfo$"></app-obstacle-layer-config>
@if (isLegendVisible) {
  <app-obstacle-layer-legend [providerInfo$]="this.ProviderInfo$"></app-obstacle-layer-legend>
}
<app-obstacle-raw-details></app-obstacle-raw-details>
<app-obstacle-road-details></app-obstacle-road-details>
@if (isHistoryVisible) {
  <app-obstacle-history-control
    (historyClosed)="handleHistoryClosed()"
  ></app-obstacle-history-control>
}
<app-last-backend-call></app-last-backend-call>
